/**
 * Trim leading and trailing white space from string fields
 * Replace consecutive white spaces (including tbose from tabs) in string fields with sing white space
 * @param {object} data - form data for submit
 * @returns {object} cleaned form data
 */

const cleanWhitespace = data => {
  if (typeof data === 'string')
    return data
      .trim()
      .replace(/\t/g, ' ') // replace tab with one space
      .replace(/ {2,}/g, ' ') // replace consecutive spaces with one space
      .replace(/ *\r?\n */g, '\n'); // replace newline or carriage return surrounded by any number of spaces with just newline
  // recursion for array data
  if (Array.isArray(data)) return data.map(cleanWhitespace);
  // recursion for object data
  if (data && typeof data === 'object' && data.constructor === Object) {
    return Object.fromEntries(
      Object.entries(data).map(([k, v]) => [k, cleanWhitespace(v)]),
    );
  }
  return data;
};

export default cleanWhitespace;
